import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faJar, faSlash, faOlive } from '@fortawesome/pro-solid-svg-icons';
import {
  faBolt,
  faCandyBar,
  faCupStraw,
  faGlassEmpty,
  faGrillHot,
  faSnowflake,
  faWaterLadder,
  faWheat,
  faXmarksLines,
  faUtensils as faSharpFaUtensils,
  faPerson as faSharpLightPerson,
} from '@fortawesome/sharp-light-svg-icons';
import { faWineBottle } from '@fortawesome/sharp-regular-svg-icons';
import {
  faAirConditioner,
  faBabyCarriage,
  faBedEmpty,
  faBeerMug,
  faCartFlatbedSuitcase,
  faChargingStation,
  faCheese,
  faChild as faLightChild,
  faChildReaching,
  faCircleParking,
  faClock,
  faCoffeePot,
  faCow,
  faDryerHeat,
  faDryer,
  faForkKnife,
  faGarage,
  faOven,
  faPlateUtensils,
  faRv,
  faScrewdriverWrench,
  faT,
  faTurkey as faLightFaTurkey,
  faTv,
  faTablePicnic,
  faWashingMachine,
  faWaterLadder as faLightFaWaterLadder,
  faWavePulse,
  faPawSimple,
  faUtensils,
  faHouse,
  faToilet,
} from '@fortawesome/pro-light-svg-icons';
import { faSquareRing, faHouseUser } from '@fortawesome/pro-regular-svg-icons';
import {
  faBaby,
  faBalloons,
  faBee,
  faBeerMug as faThinFaBeerMug,
  faBenchTree,
  faBicycle,
  faBottleDroplet,
  faCandy,
  faChild,
  faCircleParking as faThinFaCircleParking,
  faCircle,
  faCookie,
  faDumpster,
  faElevator,
  faFaceGrinTongue,
  faFaucetDrip,
  faFence,
  faFireplace,
  faFishingRod,
  faFlowerTulip,
  faGarage as faThinFaGarage,
  faGolfFlagHole,
  faHandHoldingBox,
  faHotTubPerson,
  faIceCream,
  faIcons,
  faJarWheat,
  faKitchenSet,
  faMicrowave,
  faMushroom,
  faPear,
  faPepperHot,
  faPersonHiking,
  faPerson,
  faPlug,
  faRefrigerator,
  faRoute,
  faSausage,
  faSpa,
  faSteak,
  faSuitcaseRolling,
  faTankWater,
  faTennisBall,
  faTomato,
  faTreeDeciduous,
  faUser,
  faWater,
  faWheelchair,
  faWifi,
  faWind,
  faWineBottle as faThinFaWineBottle,
  faB,
  faBurgerSoda,
  faBurrito,
  faCarrot,
  faChopsticks,
  faHatChef,
  faK,
  faLeaf,
  faLobster,
  faPig,
  faTurkey as faThinFaTurkey,
  faE,
  faA,
  faU,
  faSalad,
  faEarthAfrica,
  faTicket,
} from '@fortawesome/pro-thin-svg-icons';
import { IconName, findIconDefinition, library } from '@fortawesome/fontawesome-svg-core';

interface IFaIconProps {
  icon: string;
}

const prefixes = {
  'fa-solid': 'fas',
  'fa-thin': 'fat',
  'fa-light': 'fal',
  'fa-sharp': 'fass',
  'fa-regular': 'fa',
};

export const FaIcon = ({ icon }: IFaIconProps) => {
  const prefix = prefixes[icon.split(' ')[0]];
  const iconName: IconName = icon.split(' ')[1].replace('fa-', '') as IconName;

  const libraryIcon = findIconDefinition({ prefix, iconName });
  return <FontAwesomeIcon icon={libraryIcon} color="#f2604d" />;
};

library.add(
  faAirConditioner,
  faPawSimple,
  faBabyCarriage,
  faBedEmpty,
  faBeerMug,
  faCartFlatbedSuitcase,
  faChargingStation,
  faCheese,
  faLightChild,
  faChildReaching,
  faCircleParking,
  faClock,
  faCoffeePot,
  faCow,
  faDryerHeat,
  faDryer,
  faForkKnife,
  faGarage,
  faOven,
  faPlateUtensils,
  faRv,
  faScrewdriverWrench,
  faT,
  faTablePicnic,
  faLightFaTurkey,
  faTv,
  faWashingMachine,
  faLightFaWaterLadder,
  faWavePulse,
  faHouse,
  faSquareRing,
  faHouseUser,
  faBolt,
  faCandyBar,
  faCupStraw,
  faGlassEmpty,
  faGrillHot,
  faSharpLightPerson,
  faSnowflake,
  faWaterLadder,
  faWheat,
  faXmarksLines,
  faWineBottle,
  faJar,
  faSlash,
  faBaby,
  faBalloons,
  faBee,
  faThinFaBeerMug,
  faBenchTree,
  faBicycle,
  faBottleDroplet,
  faCandy,
  faChild,
  faThinFaCircleParking,
  faCircle,
  faCookie,
  faDumpster,
  faElevator,
  faFaceGrinTongue,
  faFaucetDrip,
  faFence,
  faFireplace,
  faFishingRod,
  faFlowerTulip,
  faThinFaGarage,
  faGolfFlagHole,
  faHandHoldingBox,
  faHotTubPerson,
  faIceCream,
  faIcons,
  faJarWheat,
  faKitchenSet,
  faMicrowave,
  faMushroom,
  faPear,
  faPepperHot,
  faPersonHiking,
  faPerson,
  faPlug,
  faRefrigerator,
  faRoute,
  faSausage,
  faSpa,
  faSteak,
  faSuitcaseRolling,
  faTankWater,
  faTennisBall,
  faTomato,
  faTreeDeciduous,
  faUser,
  faWater,
  faWheelchair,
  faWifi,
  faWind,
  faThinFaWineBottle,
  faUtensils,
  faSharpFaUtensils,
  faOlive,
  faA,
  faB,
  faBurgerSoda,
  faBurrito,
  faCarrot,
  faChopsticks,
  faHatChef,
  faK,
  faLeaf,
  faLobster,
  faPig,
  faThinFaTurkey,
  faE,
  faU,
  faSalad,
  faEarthAfrica,
  faToilet,
  faSharpFaUtensils,
  faSharpLightPerson,
  faLightChild,
  faLightFaTurkey,
  faLightFaWaterLadder,
  faThinFaBeerMug,
  faThinFaCircleParking,
  faThinFaGarage,
  faThinFaWineBottle,
  faThinFaTurkey,
  faTicket
);
